import ReactModal from 'react-modal';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { closePopup, type PopupState } from 'store/config';
import { AgxButton } from '@urbanx/agx-ui-components';
import './Popup.scss';

interface PopupProps {
  selector: string;
}

interface PopupContentProps {
  title: PopupState['title'];
  body: PopupState['body'];
  onConfirm: PopupState['onConfirm'];
  buttonText: PopupState['buttonText'];
  onClose: () => void;
}

const PopupContent = ({
  title,
  body,
  onConfirm,
  buttonText: { close, confirm },
  onClose,
}: PopupContentProps) => (
  <>
    <span
      className="absolute cursor-pointer text-lg text-gray-400 top-0 right-4 btn-x"
      onClick={onClose}
    >
      x
    </span>
    {title && <h2 className="text-xl font-semibold text-center">{title}</h2>}
    {body && <p className="text-md text-center">{body}</p>}
    <div className="flex justify-center mt-4">
      {close && <AgxButton onClick={onClose} text={close} />}
      {confirm && <AgxButton onClick={() => onConfirm?.()} text={confirm} />}
    </div>
  </>
);

const Popup = ({ selector }: PopupProps) => {
  const {
    popup: { id, open, title, body, onConfirm, buttonText },
  } = useAppSelector((state) => state.config);

  const dispatch = useAppDispatch();
  const onClose = () => dispatch(closePopup());

  const popupStyles = {
    overlay: {
      backgroundColor: 'rgba(40,40,40, 0.75)',
    },
    content: {
      height: 'fit-content',
      width: 'fit-content',
      border: '1px solid #ccc',
      background: '#fff',
      borderRadius: '16px',
      outline: 'none',
      margin: '10rem auto',
    },
  };

  return (
    <ReactModal
      id={id}
      testId={id}
      style={popupStyles}
      parentSelector={() => document.querySelector(selector) || new HTMLElement()} //Portal
      ariaHideApp={false}
      isOpen={open}
      onRequestClose={onClose}
    >
      <PopupContent
        title={title}
        body={body}
        onConfirm={onConfirm}
        buttonText={buttonText}
        onClose={onClose}
      />
    </ReactModal>
  );
};

export default Popup;
